import { getSecureItem } from "utils/SecureStorage";

let permissionCache = null;
let cachedRoleId = null;

const initializePermissionSystem = () => {
  const roleId = Number(getSecureItem("role_id"));
  const entities = getSecureItem("entities") || [];
  const accessControl = getSecureItem("accessControl") || [];

  // If already initialized for this role → skip
  if (permissionCache && cachedRoleId === roleId) return;

  cachedRoleId = roleId;
  permissionCache = {};

  // Build entity_id → entity_name map
  const entityIdToName = {};
  entities.forEach((entity) => {
    entityIdToName[entity.id] = entity.name.toLowerCase();
  });

  // Build permission cache by entity name
  accessControl.forEach((perm) => {
    if (perm.role_id === roleId) {
      const entityName = entityIdToName[perm.entity_id];

      if (!entityName) return;

      permissionCache[entityName] = {
        read: perm.can_read,
        create: perm.can_create,
        update: perm.can_update,
        delete: perm.can_delete,
      };
    }
  });
};

const normalizeEntityName = (name) => {
  if (!name) return "";

  let lower = name.toLowerCase().trim();

  // convert underscore and dash to space
  lower = lower.replace(/[_-]/g, " ");

  // remove extra spaces
  lower = lower.replace(/\s+/g, " ");

  // singular conversion
  if (lower.endsWith("ies")) {
    lower = lower.slice(0, -3) + "y";
  } else if (lower.endsWith("s")) {
    lower = lower.slice(0, -1);
  }

  return lower;
};

export const hasPermission = (entityName, action) => {
  const roleId = Number(getSecureItem("role_id"));

  // Role 1 & 2 → Full Access
  if ([1, 2].includes(roleId)) return true;

  initializePermissionSystem();

  const normalized = normalizeEntityName(entityName);

return ( permissionCache?.[normalized]?.[action] || false);
};

// Clean helpers
export const canRead = (entity) => hasPermission(entity, "read");
export const canCreate = (entity) => hasPermission(entity, "create");
export const canUpdate = (entity) => hasPermission(entity, "update");
export const canDelete = (entity) => hasPermission(entity, "delete");

export const resetPermissionCache = () => {
  permissionCache = null;
  cachedRoleId = null;
};